import { SubRoute } from "@/components/TabMenu/TabMenu.decl";
import { Slice } from "../store.decl";

type Source = SubRoute | "insights_cta" | null;

export type EvaluationTabSourceSliceState = {
  evaluationTabSource: Source;
  setEvaluationTabSource: (source: Source) => void;
  // We should not track if we directly load the page on /evaluation routes.
  shouldTrackEvaluationTabSource: boolean;
  setShouldTrackEvaluationTabSource: (bool: boolean) => void;
};

export const createEvaluationTabSourceSlice: Slice<
  EvaluationTabSourceSliceState
> = (set) => ({
  evaluationTabSource: null,
  setEvaluationTabSource: (source) => {
    set(() => ({
      evaluationTabSource: source,
    }));
  },
  shouldTrackEvaluationTabSource: false,
  setShouldTrackEvaluationTabSource: (bool) => {
    set(() => ({
      shouldTrackEvaluationTabSource: bool,
    }));
  },
});
